import KendoChat from './KendoChat'
import KendoChatInstaller from './kendo-chat-installer'
import KendoChatToolbarButton from './KendoChat/KendoChatToolbarButton'

export { KendoChat, KendoChat as Chat, KendoChatInstaller as ChatInstaller, KendoChatToolbarButton, KendoChatToolbarButton as ChatToolbarButton}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/index.js